export default __webpack_public_path__ + "static/media/video_icon_-_resource_page-removebg-preview.48bf3d4c.png";